import React, { useState, useEffect, useMemo, useCallback } from "react";
import { db, auth, completaProfilo, saveApiKey }  from "./FirestoreDataLoader.tsx";
import { Eye, EyeOff, Lock, UserCheck, Mail } from "lucide-react";
import { useConfirmToast } from "./alertFunction.tsx";
import { useNavigate } from "react-router-dom";
import { finalizeInviteFrontend } from "./verificaTokenInvito.tsx";
import { doc, getDoc, runTransaction, deleteField, DocumentReference } from 'firebase/firestore';
import { useBeforeUnload } from "react-router-dom";
import { Button, TextField, FormControl, Select, MenuItem} from '@mui/material';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import InputAdornment from '@mui/material/InputAdornment';
import provinceCitta from './province_citta.json';

const country = {
  "AF": "Afghanistan", "AX": "Isole Åland", "AL": "Albania", "DZ": "Algeria", "AS": "Samoa Americana",
  "AD": "Andorra", "AO": "Angola", "AI": "Anguila", "AQ": "Antartide", "AG": "Antigua e Barbuda",
  "AR": "Argentina", "AM": "Armenia", "AW": "Aruba", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaigian",
  "BS": "Bahamas", "BH": "Bahrein", "BD": "Bangladesh", "BB": "Barbados", "BY": "Bielorussia", "BE": "Belgio",
  "BZ": "Belize", "BJ": "Benin", "BM": "Bermuda", "BT": "Bhutan", "BO": "Bolivia", "BQ": "Caribbean Netherlands",
  "BA": "Bosnia ed Erzegovina", "BW": "Botswana", "BV": "Isole Bouvet", "BR": "Brasile","IT": "Italia", "IO": "Territorio britannico dell'Oceano Indiano",
  "BN": "Brunei", "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "KH": "Cambogia", "CM": "Camerun",
  "CA": "Canada", "CV": "Capo Verde", "KY": "Isole Cayman", "CF": "Repubblica Centrafricana", "TD": "Ciad",
  "CL": "Cile", "CN": "Cina", "CX": "Isole Christmas", "CC": "Isole Cocos", "CO": "Colombia", "KM": "Comore",
  "CG": "Congo", "CD": "Repubblica Democratica del Congo", "CK": "Isole Cook", "CR": "Costa Rica", "CI": "Costa d'Avorio","HR": "Croazia",
  "CU": "Cuba", "CW": "Curaçao", "CY": "Cipro", "CZ": "Repubblica Ceca", "DK": "Danimarca","DJ": "Gibuti",
  "DM": "Dominica", "DO": "Repubblica Dominicana", "EC": "Ecuador", "EG": "Egitto", "SV": "El Salvador",
  "GQ": "Guinea Equatoriale", "ER": "Eritrea", "EE": "Estonia", "ET": "Etiopia", "FK": "Isole Falkland",
  "FO": "Isole Fær Øer", "FJ": "Figi", "FI": "Finlandia", "FR": "Francia", "GF": "Guyana Francese",
  "PF": "Polinesia Francese", "TF": "Terre Australi e Antartiche Francesi", "GA": "Gabon", "GM": "Gambia",
  "GE": "Georgia", "DE": "Germania", "GH": "Ghana", "GI": "Gibilterra", "GR": "Grecia", "GL": "Groenlandia",
  "GD": "Grenada", "GP": "Guadalupa", "GU": "Guam", "GT": "Guatemala", "GG": "Guernsey", "GN": "Guinea",
  "GW": "Guinea-Bisau", "GY": "Guyana", "HT": "Haiti", "HM": "Isole Heard e McDonald", "VA": "Vaticano",
  "HN": "Honduras", "HK": "Hong Kong", "HU": "Ungheria", "IS": "Islanda", "IN": "India", "ID": "Indonesia",
  "IR": "Iran", "IQ": "Iraq", "IE": "Irlanda", "IM": "Isola di Man", "IL": "Israele","JM": "Giamaica", "JP": "Giappone", 
  "JE": "Jersey", "JO": "Giordania", "KZ": "Kazakistan", "KE": "Kenya", "KI": "Kiribati", "KP": "Corea del Nord", "KR": "Corea del Sud", 
  "KW": "Kuwait", "KG": "Kirgizistan", "LA": "Laos", "LV": "Lettonia", "LB": "Libano", "LS": "Lesotho", "LR": "Liberia", "LY": "Libia",
  "LI": "Liechtenstein", "LT": "Lituania", "LU": "Lussemburgo", "MO": "Macau", "MK": "Macedonia del Nord", "MG": "Madagascar",
  "MW": "Malawi", "MY": "Malesia", "MV": "Maldive", "ML": "Mali", "MT": "Malta", "MH": "Isole Marshall",
  "MQ": "Martinica", "MR": "Mauritania", "MU": "Maurizio", "YT": "Mayotte", "MX": "Messico", "FM": "Micronesia",
  "MD": "Moldavia", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MS": "Montserrat", "MA": "Marocco",
  "MZ": "Mozambico", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Paesi Bassi",
  "NC": "Nuova Caledonia", "NZ": "Nuova Zelanda", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria", "NU": "Niue",
  "NF": "Isole Norfolk", "MP": "Isole Marianne Settentrionali", "NO": "Norvegia", "OM": "Oman", "PK": "Pakistan",
  "PW": "Palau", "PS": "Palestina", "PA": "Panama", "PG": "Papua Nuova Guinea", "PY": "Paraguay", "PE": "Perù",
  "PH": "Filippine", "PN": "Isole Pitcairn", "PL": "Polonia", "PT": "Portogallo", "PR": "Porto Rico", "QA": "Qatar",
  "RE": "Riunione", "RO": "Romania", "RU": "Russia", "RW": "Ruanda", "BL": "Saint-Barthélemy", "SH": "Sant'Elena",
  "VC": "Saint Vincent e Grenadine", "WS": "Samoa", "SM": "San Marino", "ST": "Sao Tomé e Principe",
  "SA": "Arabia Saudita", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", 
  "SX": "Sint Maarten", "SK": "Slovacchia", "SI": "Slovenia", "SB": "Isole Salomone", "SO": "Somalia", "ZA": "Sudafrica",
  "GS": "Georgia del Sud e isole Sandwich meridionali", "SS": "Sudan del Sud", "ES": "Spagna", "LK": "Sri Lanka",
  "SD": "Sudan", "SR": "Suriname", "SJ": "Svalbard e Jan Mayen", "SZ": "Eswatini", "SE": "Svezia",
  "CH": "Svizzera", "SY": "Siria", "TW": "Taiwan", "TJ": "Tagikistan", "TZ": "Tanzania", "TH": "Thailandia",
  "TL": "Timor Est", "TG": "Togo", "TK": "Tokelau", "TO": "Tonga", "TT": "Trinidad e Tobago", "TN": "Tunisia",
  "UA": "Ucraina", "AE": "Emirati Arabi Uniti", "GB": "Regno Unito", "US": "Stati Uniti",
  "UM": "Isole minori lontane degli Stati Uniti", "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VE": "Venezuela", "VN": "Vietnam",
  "VG": "Isole Vergini Britanniche", "VI": "Isole Vergini Statunitensi", "WF": "Wallis e Futuna","EH": "Sahara Occidentale", 
  "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe", "XK": "Kosovo", "XI": "Isola di Man", "EL": "Elisabetta"
}

interface NomeCap {
 nome: string;
 cap: string;
}

interface CittaPerProvincia {
  provincia: string; 
  città: NomeCap[];
}

export interface FormProfiloData {
  pIva: string;
  ragioneSociale: string;
  indirizzo: string;
  cap: string;
  comune: string;
  nazione: string;
  apiKey?: string;
}

interface ProfiloData {
  tipoAccount: string;
  pIva: string;
  ragioneSociale: string;
  indirizzo: string;
  cap: string;
  comune: string;
  nazione: string;
  invitatoDaUID?: string;
  statoInvito?: string;
}

interface ComuneDettaglio {
    suggerimentoFormattato: string;
    cap: string;
}

export const FormWithEntry = ({
  firstTime, loading, onClose, tipoAccount, onDataSubmit, emailInvitante, 
  partitaIva, RSociale, address, CAP, city, initialCountry
}: {
  firstTime: boolean, loading: boolean,  tipoAccount: string, onDataSubmit: (data: FormProfiloData) => void, emailInvitante: string | null, 
  onClose?:any, partitaIva?: string, RSociale?: string, address?: string, CAP?: string, city?: string, initialCountry?: string
}) => {
  const initialPIvaFull = partitaIva || '';
  const initialPIvaSigla = initialPIvaFull.substring(0, 2).toUpperCase() || initialCountry || 'IT';
  const initialPIvaCodice = initialPIvaFull.length > 2 ? initialPIvaFull.substring(2) : '';

  const [pIvaCodice, setPIvaCodice] = useState<string>(initialPIvaCodice);
  const [pIvaSigla, setPIvaSigla] = useState<string>(initialPIvaSigla);
  const [errorPIva, setErrorPIva] = useState<string | null>(null);

  const [suggerimentiPIvaSigla, setSuggerimentiPIvaSigla] = useState<{ code: string; fullText: string }[]>([]);
  const [mostraSuggerimentiPIvaSigla, setMostraSuggerimentiPIvaSigla] = useState<boolean>(false);

  const [ragioneSociale, setRagioneSociale] = useState<string>(RSociale || '');
  const [indirizzo, setIndirizzo] = useState<string>(address || '');
  const [cap, setCap] = useState<string>(CAP || '');

  const [comune, setComune] = useState<string>(city || '');
  const [suggerimentiComune, setSuggerimentiComune] = useState<string[]>([]);

  const [nazione, setNazione] = useState<string>(initialCountry || 'IT');
  const [suggerimentiNazione, setSuggerimentiNazione] = useState<{ code: string; label: string; fullText: string }[]>([]);
  const [mostraSuggerimentiNazione, setMostraSuggerimentiNazione] = useState<boolean>(false); 

  const [errorNazione, setErrorNazione] = useState<boolean>(false);

  //chiudi sugerimenti con click
  useEffect(() => {
    const handleMostraSuggerimenti = (e:MouseEvent) => {
      if (mostraSuggerimentiNazione && e) setMostraSuggerimentiNazione(false);
      if (mostraSuggerimentiPIvaSigla && e) setMostraSuggerimentiPIvaSigla(false);
    };
    document.addEventListener('click', handleMostraSuggerimenti);
    return () => {
      document.removeEventListener('click', handleMostraSuggerimenti);
    };
  }, [mostraSuggerimentiNazione, mostraSuggerimentiPIvaSigla])

  // previene il salvataggio con enter.
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (errorNazione && e) setErrorNazione(false);
    if (errorPIva && e) setErrorPIva(null);
    if (e.key === 'Enter') {
      e.preventDefault(); 
    }
  };
    
  // Memorizzazione di tutti i comuni con la loro provincia
  const tuttiIComuni = useMemo(() => {
    const comuni: { [key: string]: ComuneDettaglio } = {};
    (provinceCitta as CittaPerProvincia[]).forEach(item => {
      const sigla = item.provincia.split(' ')[0]; 
      const nomeProvincia = item.provincia.match(/\((.*?)\)/)?.[1] || '';

      item.città.forEach(citta => {
        const suggerimento = nomeProvincia.toLowerCase() === citta.nome.toLowerCase() 
            ? citta.nome 
            : `${citta.nome} (${sigla.trim()})`;
        
        const chiaveRicerca = citta.nome.toLowerCase();

        comuni[chiaveRicerca] = {
            suggerimentoFormattato: suggerimento,
            cap: citta.cap,
        };
      });
    });
    return comuni;
  }, []);
    
  // mappa i dati della nazione per la ricerca/suggerimento
  const nazioniPerRicerca = useMemo(() => {
    return Object.entries(country).map(([code, name]) => ({
      code, 
      name: name,
      fullText: `${code} ${name}`, 
      normalizedSearch: `${code.toLowerCase()} ${name.toLowerCase()}`
    })).sort((a, b) => a.code.localeCompare(b.code));
  }, []);
  

  // GESTIONE DELLA SIGLA P.IVA 
  const handlePIvaSiglaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputSigla = e.target.value.toUpperCase();
    
    // Permetti solo lettere e limita a 2 caratteri
    const cleanedInput = inputSigla.replace(/[^A-Z]/g, '').substring(0, 2);
    
    setPIvaSigla(cleanedInput);
    setNazione(cleanedInput);
    setErrorPIva(null);
    
    if (cleanedInput.length >= 1) {
      const searchText = cleanedInput.toLowerCase();
      // Corrispondenza con il CODICE 
      const matchesByCode = nazioniPerRicerca
        .filter(item => item.code.toLowerCase().startsWith(searchText))
        .map(item => ({ code: item.code, fullText: item.fullText }));

      // Identifica i codici già trovati per evitare duplicati
      const matchedCodes = new Set(matchesByCode.map(item => item.code));

      // Corrispondenza con il NOME (solo se non già trovati per il codice)
      const matchesByName = nazioniPerRicerca
        .filter(item => 
          !matchedCodes.has(item.code) && // Evita duplicati
          item.name.toLowerCase().includes(searchText)
        )
        .map(item => ({ code: item.code, fullText: item.fullText }));

      // Combina i risultati
      const suggerimenti = [...matchesByCode, ...matchesByName]; 

      setSuggerimentiPIvaSigla(suggerimenti);
      setMostraSuggerimentiPIvaSigla(true);
    } else {
      setSuggerimentiPIvaSigla([]);
      setMostraSuggerimentiPIvaSigla(false);
    }
  };

  // SELEZIONE SUGGERIMENTO SIGLA P.IVA 
  const handleSelectPIvaSigla = (code: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setPIvaSigla(code);
    setNazione(code);
    setMostraSuggerimentiPIvaSigla(false);
  };
  
  // Funzione per i suggerimenti 
  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (mostraSuggerimentiPIvaSigla) {
        setMostraSuggerimentiPIvaSigla(false);
    } else {
        if (pIvaSigla.length === 0 || pIvaSigla.length === 2) { //capo vuoto
            const tutti = nazioniPerRicerca.map(item => ({
                code: item.code,
                fullText: item.fullText
            })).sort((a, b) => a.code.localeCompare(b.code));
            setSuggerimentiPIvaSigla(tutti);
        } else {
            // suggerimenti sulla base del valore attuale 
            const searchText = pIvaSigla.toLowerCase();

            // Corrispondenza per CODICE 
            const matchesByCode = nazioniPerRicerca
                .filter(item => item.code.toLowerCase().startsWith(searchText))
                .map(item => ({ code: item.code, fullText: item.fullText }));

            const matchedCodes = new Set(matchesByCode.map(item => item.code));

            // Corrispondenza per NOME
            const matchesByName = nazioniPerRicerca
                .filter(item =>
                    !matchedCodes.has(item.code) && 
                    item.name.toLowerCase().includes(searchText)
                )
                .map(item => ({ code: item.code, fullText: item.fullText }));

            // Combina 
            const suggerimenti = [...matchesByCode, ...matchesByName];
                
            setSuggerimentiPIvaSigla(suggerimenti);
        }
        setMostraSuggerimentiPIvaSigla(true);
    }
  };

  // CODICE NUMERICO P.IVA CON VALIDAZIONE 
  const handlePIvaCodiceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputCodice = e.target.value.trim();
    
    // solo numeri
    const numericInput = inputCodice.replace(/[^0-9]/g, '');
     setPIvaCodice(numericInput);

    // Controllo della lunghezza
    if (numericInput.length === 0) {
        setErrorPIva('Il codice Partita IVA non può essere vuoto.');
    } else if (numericInput.length < 11) {
        setErrorPIva(`Deve contenere 11 numeri. Mancano ${11 - numericInput.length} cifre.`);
    } else if (numericInput.length > 11) {
        setErrorPIva(`Il codice Partita IVA è troppo lungo (max 11 cifre).`);
    } else {
        setErrorPIva(null);
    }
  };

  // FUNZIONE DI AUTOCMPLETAMENTO COMUNE
  const handleComuneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputComune = e.target.value;
    setComune(inputComune);
    setCap('');

    if (inputComune.length < 2) {
      setSuggerimentiComune([]);
      return;
    }

   const suggerimenti = Object.keys(tuttiIComuni)
      .filter(cittaKey => cittaKey.startsWith(inputComune.toLowerCase()))
      .map(cittaKey => tuttiIComuni[cittaKey].suggerimentoFormattato)
      .slice(0, 10) ; // Limita a 10 suggerimenti

    setSuggerimentiComune(suggerimenti);
  };

  const handleSelectComune = (suggerimento: string) => {
    setComune(suggerimento);
    setSuggerimentiComune([]);
    const nomeComunePulito = suggerimento.replace(/\s*\(\s*[A-Z]{2}\s*\)/, '').trim().toLowerCase();

    // aggiungamo anche il cap
    const dettaglioComune = tuttiIComuni[nomeComunePulito];
    if (dettaglioComune) {
        setCap(dettaglioComune.cap);
    } else {
        setCap('');
    }
  };

    // FUNZIONE DI AUTOCMPLETAMENTO NAZIONE 
  const handleNazioneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputText = e.target.value.toUpperCase();
    // Limita a 2 caratteri, niente numeri o simboli
    const cleanedInput = inputText.replace(/[^A-Z]/g, '').substring(0, 2); 
    setNazione(cleanedInput);

    if (cleanedInput.length < 1 || /[^A-Z]/.test(inputText)) {
      setErrorNazione(true);
    } else {
      setErrorNazione(false);
    }

    if (cleanedInput.length >= 1) {
    const searchText = cleanedInput.toLowerCase();

    // Corrispondenza con il CODICE 
    const matchesByCode = nazioniPerRicerca
      .filter(item => item.code.toLowerCase().startsWith(searchText))
      .map(item => ({ 
        code: item.code, 
        label: item.fullText.split(' ')[0],
        fullText: item.fullText 
      }));

    const matchedCodes = new Set(matchesByCode.map(item => item.code));

      // Corrispondenza con il NOME 
      const matchesByName = nazioniPerRicerca.filter(item =>
          !matchedCodes.has(item.code) && 
          item.name.toLowerCase().includes(searchText)
        )
        .map(item => ({ 
          code: item.code, 
          label: item.fullText.split(' ')[0],
          fullText: item.fullText 
        })
      );

      // Combina i risultati
      const suggerimenti = [...matchesByCode, ...matchesByName]; 

      setSuggerimentiNazione(suggerimenti);
      setMostraSuggerimentiNazione(true); 
    } else {
      setSuggerimentiNazione([]);
      setMostraSuggerimentiNazione(false); 
    }
  };

  // FUNZIONE PER SELEZIONARE LA NAZIONE
  const handleSelectNazione = (code: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setNazione(code); 
    setMostraSuggerimentiNazione(false);
  };

  //Funzione per l'icona Nazione
  const handleIconClickNazione = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (mostraSuggerimentiNazione) {
      setMostraSuggerimentiNazione(false);
    } else {
      if (nazione.length === 0 || nazione.length === 2) { 
        const tutti = nazioniPerRicerca.map(item => ({
          code: item.code,
          label: item.fullText.split(' ')[0], 
          fullText: item.fullText
        })).sort((a, b) => a.code.localeCompare(b.code));
            
        setSuggerimentiNazione(tutti); 
      } else {
        // Ricalcola i suggerimenti
        const searchText = nazione.toLowerCase();

        //Corrispondenza per CODICE 
        const matchesByCode = nazioniPerRicerca
          .filter(item => item.code.toLowerCase().startsWith(searchText))
          .map(item => ({ 
            code: item.code, 
            label: item.fullText.split(' ')[0],
            fullText: item.fullText 
          }));

        const matchedCodes = new Set(matchesByCode.map(item => item.code));

        // Corrispondenza per NOME
        const matchesByName = nazioniPerRicerca
          .filter(item => 
            !matchedCodes.has(item.code) && 
            item.name.toLowerCase().includes(searchText) 
          ).map(item => ({
            code: item.code, 
            label: item.fullText.split(' ')[0],
            fullText: item.fullText 
          }));

        // Combina 
        const suggerimenti = [...matchesByCode, ...matchesByName]; 
            
        setSuggerimentiNazione(suggerimenti);
      }
      setMostraSuggerimentiNazione(true);
    }
  };
    

  // FUNZIONE PER GESTIRE IL SUBMIT DEL FORM
  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Validazione nazione
    if (nazione.length > 2 || nazione.length === 0 || /[^A-Z]/.test(nazione)) {
      setErrorNazione(true);
      return;
    }
    
    // Validazione Partita IVA 
    const isPIvaValid = pIvaCodice.length === 11 && /^\d+$/.test(pIvaCodice);
    if (!isPIvaValid) {
        if (pIvaCodice.length < 11) {
            setErrorPIva(`Il codice IVA deve essere di 11 cifre. Per favore correggi prima di salvare.`);
        } else if (!/^\d+$/.test(pIvaCodice)) {
            setErrorPIva(`Il codice IVA deve contenere solo numeri.`);
        }
        return;
    }
    
    const pIvaCompleta = pIvaSigla + pIvaCodice;

    setErrorNazione(false);
    const datiDaInviare: FormProfiloData = {
      pIva: pIvaCompleta,
      ragioneSociale,
      indirizzo,
      cap,
      comune,
      nazione,
    };
        
    // Chiama la funzione fornita dal genitore con tutti i dati raccolti
    onDataSubmit(datiDaInviare);
  };


  const suggerimentiListStyle: React.CSSProperties = {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    border: '1px solid #d1d5db',
    borderRadius: '0.5rem',
    zIndex: 10,
    listStyle: 'none',
    padding: '0',
    margin: '0.25rem 0 0 0',
    maxHeight: '90px',
    overflowY: 'auto',
  };
  

  const suggerimentoItemStyle: React.CSSProperties = {
    padding: '0.5rem 0.75rem',
    cursor: 'pointer',
    borderBottom: '1px solid #f3f4f6',
    color: '#4b5563',
  };

  const fullCountryNameStyle: React.CSSProperties = {
    color: '#9ca3af', 
    marginLeft: '0.5rem',
  };

  const isAzienda = tipoAccount === 'azienda';
  const isCliente = tipoAccount === 'cliente';
  const isCollaboratore = tipoAccount === 'collaboratore';
  const isInvitato = isCliente || isCollaboratore;


  return (
    <form onSubmit={handleFormSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {/* DISCLAIMER INVITANTE */}
      {isInvitato && emailInvitante && (
        <div style={{ marginBottom: '0.75rem', padding: '0.75rem', borderRadius: '0.5rem', backgroundColor: '#eef2ff', border: '1px solid #a2c5f3ff', display:'flex', alignItems:'center', gap:'0.5rem' }}>
          <Mail size={20} style={{ color: '#2976ceff' }} />
          <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#2976ceff', margin: 0, userSelect: 'none' }}>
            Invitato da: <strong>{emailInvitante}</strong>
          </p>
        </div>
      )}  

      {/*Campo Tipo di Profilo*/}
      <TextField
        type="text"
        label="Tipo di Profilo"
        value={tipoAccount.charAt(0).toUpperCase() + tipoAccount.slice(1)} 
        sx={{backgroundColor:'#f0f0f0ff', color:'#000000ff', userSelect:'none'}} 
        disabled 
        fullWidth
        size='small'
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Lock style={{ width:'1.3rem', height:'2rem', color: '#7e8083ff'}} />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        type="text"
        label={(isCliente || isAzienda) ? "Ragione Sociale" : "Nome e Cognome"}
        value={ragioneSociale}
        onChange={(e) => setRagioneSociale(e.target.value)}
        fullWidth
        size='small'
        required
        onKeyDown={handleKeyDown}
      />

      {/* CAMPI ANAGRAFICI */}
      {(!isCollaboratore) && (
        <>
          <div style={{ position: 'relative' }}>
            <TextField
              type="text"
              label="Partita IVA"
              value={pIvaCodice} 
              onChange={handlePIvaCodiceChange}
              fullWidth
              size='small'
              required
              error={!!errorPIva}
              helperText={errorPIva && errorPIva} 
              onKeyDown={handleKeyDown}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {/* Menu a tendina per la sigla del paese (max 2 caratteri) */}
                    <TextField
                      variant='standard'
                      value={pIvaSigla}
                      onChange={handlePIvaSiglaChange}
                      inputProps={{ maxLength: 2 }}
                      //onClick={handleIconClick}
                      onMouseDown={(e) => e.stopPropagation()}
                      sx={{ 
                        width: '20px', 
                        textAlign: 'center',
                        cursor: 'pointer',
                        border:0,
                        '& .MuiInputBase-input': { 
                          padding: 0,
                          textAlign: 'center',
                          fontWeight: 'bold',
                          border:0,
                        },
                        // Rimuove la linea standard di Material UI
                        '& .MuiInput-underline:before': { borderBottom: 'none' },
                      }}
                    />  
                    <ArrowDropDown 
                      style={{ 
                        width: '20px',
                        color: '#6b7280', 
                        cursor: 'pointer',
                        padding:0,
                        margin:0,
                        position:'relative'
                      }} 
                      onClick={handleIconClick} 
                    />
                    {/* Lista Suggerimenti per la Sigla P.IVA */}
                    {mostraSuggerimentiPIvaSigla && suggerimentiPIvaSigla.length > 0 && (
                            <ul style={{ ...suggerimentiListStyle, left: 0, top: '40px', maxHeight:'10.5rem' }}>
                                {suggerimentiPIvaSigla.map((item) => (
                                    <li
                                        key={item.code}
                                        onClick={(e) => handleSelectPIvaSigla(item.code, e)}
                                        style={suggerimentoItemStyle}
                                    >
                                        <strong>{item.code}</strong>
                                        <span style={fullCountryNameStyle}>
                                            {item.fullText.substring(item.code.length).trim()}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <TextField
            type="text"
            label="Indirizzo"
            value={indirizzo}
            onChange={(e) => setIndirizzo(e.target.value)}
            fullWidth
            size='small'
            required
            onKeyDown={handleKeyDown}
          />
                 
          {/* Campo Comune con Autocompletamento */}
          <div style={{ position: 'relative' }}>
            <TextField
              type="text"
              label="Comune"
              value={comune}
              onChange={handleComuneChange}
              fullWidth
              size='small'
              required
              onKeyDown={handleKeyDown}
            />
            {suggerimentiComune.length > 0 && (
              <ul style={suggerimentiListStyle}>
                {suggerimentiComune.map((suggerimento) => (
                  <li 
                    key={suggerimento} 
                    onClick={() => handleSelectComune(suggerimento)}
                    style={suggerimentoItemStyle}
                  >
                    {suggerimento}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <TextField
            type="text"
            label="CAP"
            value={cap}
            onChange={(e) => setCap(e.target.value)}
            fullWidth
            size='small'
            required
            onKeyDown={handleKeyDown}
          />
          {/* Campo Nazione con Autocompletamento */}
          <div style={{ position: 'relative' }}>
            <TextField
              type="text"
              label="Nazione"
              value={nazione} 
              onChange={handleNazioneChange}
              fullWidth
              size='small'
              required
              onKeyDown={handleKeyDown}
              onMouseDown={(e) => e.stopPropagation()}
              error={errorNazione}
              helperText={errorNazione ? 'Inserire solo la sigla della nazione. (max 2 caratteri)' : ''}
              inputProps={{ maxLength: 2 }}
              InputProps={{
                 endAdornment: (
                     <InputAdornment position="end">
                        <ArrowDropDown
                          style={{
                            color: '#6b7280',
                            cursor: 'pointer',
                          }}
                          onClick={handleIconClickNazione}
                        />
                     </InputAdornment>
                 )
              }}
            />
            {mostraSuggerimentiNazione && suggerimentiNazione.length > 0 && (
              <ul style={suggerimentiListStyle}>
                {suggerimentiNazione.map((item) => (
                  <li 
                    key={item.code} 
                    onClick={(e) => handleSelectNazione(item.code, e)}
                    style={suggerimentoItemStyle}
                  >
                    {/* Mostra la Sigla in grassetto e il Nome completo in grigio chiaro */}
                    <strong>{item.code}</strong> 
                    <span style={fullCountryNameStyle}>
                      {item.fullText.substring(item.code.length).trim()}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <input type="hidden" name="nazione" value={nazione} />
        </>
      )}
      {firstTime ?
        <Button
          type="submit"
          variant='contained'
          disabled={loading}
          color={loading ? 'primary' : 'success' }
          sx={{
            mt:'1.5rem',
            padding: '0.5rem', 
            cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? 'Salvataggio...' : 'Salva i dati e Continua'}
        </Button>  :
        <div style={{display:'flex', justifyContent:'space-between'}}>
          <Button variant='outlined' color='error' sx={{ mt:'1rem', mb:'1rem', padding: '0.5rem 1rem'}} onClick={onClose}>Annulla</Button>
          <Button
            type="submit"
            variant='contained'
            color='success'
            sx={{ mt:'1rem', mb:'1rem', padding: '0.5rem 1.5rem'}}
          >
            Salva 
          </Button> 
        </div>
      }
    </form>
  );
}



export default function ProfiloUtente() {

    const { errorAlert, warningAlert, successAlert } = useConfirmToast();
    
    //incoraggia l'utente a completare l'scrizione.
    useBeforeUnload(
        useCallback((event: BeforeUnloadEvent) => {
          event.preventDefault(); 
          event.returnValue = "";
        }, [])
    );

    useEffect(() => {
        const handlePopState = () => {
            
            window.history.pushState(null, document.title, window.location.href);
            warningAlert("Devi completare il profilo prima di procedere.");
        };
        
        // aggiunge la pagina attuale per "bloccare" l'uscita
        window.history.pushState(null, document.title, window.location.href); 
        window.addEventListener('popstate', handlePopState);
        // Funzione di pulizia
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [warningAlert]);
    

    const navigate = useNavigate();
    
    const inviteData = JSON.parse(sessionStorage.getItem('inviteData') || '{}');

    // Recupera i valori se 
    const token = inviteData.token;
    const ruolo = inviteData.ruolo;
    const invitanteId = inviteData.invitanteId;
    let invitanteRef:DocumentReference<unknown, any>
    if (invitanteId){
      invitanteRef = doc(db, "utenti", invitanteId); 
    }
    const emailUtente = auth.currentUser?.email;
    const user = auth.currentUser;

    useEffect(() => {
      if (token && ruolo && user) {
        finalizeInviteFrontend(token, user.uid, ruolo)
      }
    }, [token, ruolo, user]);

    const [emailInvitante, setEmailInvitante] = useState<string | undefined>(undefined);
    const [tipoAccount, setTipoAccount] = useState<string>('azienda');
    const [ragioneSociale, setRagioneSociale] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
      const SetEmail = async() => {
        if(invitanteRef){
          const invitanteSnap = await getDoc(invitanteRef);
          const invitanteData = invitanteSnap.data() as { email: string } | undefined;
          const emailInvitante = invitanteData?.email || undefined;
          setEmailInvitante(emailInvitante);
        }
      };

      SetEmail();
    }, []);

    // Pre-compilazione Nome Utente / Recupero Ruolo
    useEffect(() => {
      if (ruolo) {
        setTipoAccount(ruolo);
      }
      // Tenta di pre-compilare il nome utente 
      if (emailUtente && !ragioneSociale) {
        const formattedName = auth.currentUser?.displayName || '' ;
        setRagioneSociale(formattedName);
      }
    }, [ruolo, emailUtente, ragioneSociale]);

    // Elimina la mappa relativa all'email dell'utente dentro inviti_emessi di chi ha invitato
    useEffect(() => {
      const cleanInvite = async () => {
        if (token && ruolo && invitanteId) {
          const EmailKey = String(emailUtente).replace(/\./g, '_');
          await runTransaction(db, async (transaction) => {
            const updateData: any = {};
            updateData[`inviti_emessi.${EmailKey}`] = deleteField();
            transaction.update(invitanteRef, updateData);
          });
        }
      };

      cleanInvite(); 
    }, [token, ruolo, inviteData, emailUtente]);


    // salva anagrafica utente
    const handleSubmit = async (datiForm: FormProfiloData) => {
      setLoading(true);

      const { pIva, ragioneSociale, indirizzo, cap, comune, nazione, apiKey } = datiForm;
      const isAzienda = tipoAccount === 'azienda';

      try {
        const userId = auth.currentUser?.uid;
        if (!userId) throw new Error("Utente non autenticato.");
    
        const datiProfilo: ProfiloData = { 
                tipoAccount,
                pIva,          
                ragioneSociale,
                indirizzo,     
                cap,         
                comune,       
                nazione,
            };

            if (emailInvitante) {
                datiProfilo.invitatoDaUID = emailInvitante;
            } else if (!token) {
                datiProfilo.statoInvito = 'Nuovo Utente';
            }

            // salvataggio
            await completaProfilo(userId, datiProfilo as any);
            
            // Salva la chiave API se Azienda
            /*if (isAzienda && apiKey) {
                await saveApiKey(userId, apiKey);
            }*/

            successAlert("", "Salvataggio completato!");
            const redirectTo = tipoAccount === 'cliente' ? "/dashboard" : "/";
            setTimeout(() => navigate(redirectTo), 1500);

        } catch (error: any) {
            errorAlert(error.message || "Errore durante il salvataggio.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb', padding: '1rem' }}>
            <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '1rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', width: '100%', maxWidth: '24rem', border: '1px solid #e5e7eb' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#374151', textAlign: 'center', marginBottom: '1.5rem', userSelect: 'none' }}>
                    Completa il tuo Profilo
                </h2>
                <FormWithEntry 
                  firstTime={true}  
                  loading={loading}
                  tipoAccount={tipoAccount}
                  onDataSubmit={handleSubmit}
                  emailInvitante={emailInvitante || ''}
                  RSociale={ragioneSociale}/>
            </div>
        </div>
    );
}